import { render, staticRenderFns } from "./quick-registration-dialog.vue?vue&type=template&id=8dba96ae&scoped=true"
import script from "./quick-registration-dialog.vue?vue&type=script&lang=js"
export * from "./quick-registration-dialog.vue?vue&type=script&lang=js"
import style0 from "./quick-registration-dialog.vue?vue&type=style&index=0&id=8dba96ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dba96ae",
  null
  
)

export default component.exports